import EntityListCard from '@repo/ui/components/cards/EntityListCard';
import { useState } from 'react';
import {
  Location,
  useCreateLocation,
  useDeleteLocation,
  useLocations,
  useUpdateLocation,
} from '../hooks/locations';
import Button from '@repo/ui/components/Button';
import Input from '@repo/ui/components/Input';

export default function LocationsEntityCard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useLocations({
    searchQuery,
    page: currentPage,
  });

  return (
    <EntityListCard
      isLoading={isLoading}
      title="Locations"
      onSearchQueryChange={setSearchQuery}
      items={data?.locations ?? []}
      itemToEntityItem={item => ({
        key: item.locationid,
        title: item.locationcode,
        subtitle: item.locationdesc,
        onClick: () => {},
      })}
      onPageChange={setCurrentPage}
      currentPage={currentPage}
      totalPages={data?.totalPages}
      AddOrUpdateItemFormComponent={AddOrUpdateLocationForm}
    />
  );
}

function AddOrUpdateLocationForm({
  item,
  onCreate,
  onUpdate,
  onDelete,
}: {
  item?: Location;
  onCreate: () => void;
  onUpdate: () => void;
  onDelete: () => void;
}) {
  const { mutate: createLocation } = useCreateLocation({
    onSuccess: onCreate,
  });

  const { mutate: updateLocation } = useUpdateLocation({
    onSuccess: onUpdate,
  });

  const { mutate: deleteLocation } = useDeleteLocation({
    onSuccess: onDelete,
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    if (item) {
      updateLocation({
        ...item,
        ...data,
      } as Location);
    } else {
      createLocation(data as Location);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4">
      <Input label="Code" name="locationcode" defaultValue={item?.locationcode} maxLength={8} />
      <Input isTextarea label="Description" name="locationdesc" defaultValue={item?.locationdesc} />
      <div className="space-x-4">
        <Button>{item ? 'Update Location' : 'Add Location'}</Button>
        {item && (
          <button
            onClick={() => deleteLocation(item.locationid)}
            type="button"
            className="rounded-md border border-red-500 px-4 py-2 text-sm text-red-500"
          >
            Delete Location
          </button>
        )}
      </div>
    </form>
  );
}
